import React, { Fragment, useState } from "react";
import Tarjetas from "./components/Tarjetas";
import { useSelector } from "react-redux";
import { change_estado } from './redux/Appslice';
import { useDispatch } from 'react-redux';
import Radio from '@mui/material/Radio';


const App = () => {

  const dispatch = useDispatch();
  const tarjetaestado = useSelector((state) => state.appState.estado[0]);
  const [tarjeta, setTarjeta] = useState("");
  const [name, setName] = useState("");
  const [cedula, setCedula] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [celular, setCelular] = useState("");
  const [laboral, setLaboral] = useState("");
  const [value,onChange]=useState(13000);
  const [selectedValue, setSelectedValue] = useState("");

    
    const continuar = () => {
      var error = document.querySelector(".error");
      if(!name){
          error.classList.add("activo");
          setTimeout(() => {
            error.classList.remove("activo");
          }, "4000");
      }else if(!cedula){
          error.classList.add("activo");
          setTimeout(() => {
            error.classList.remove("activo");
          }, "4000");
      }else if(!apellido){
        error.classList.add("activo");
        setTimeout(() => {
          error.classList.remove("activo");
        }, "4000");
      }else if(!email){
        error.classList.add("activo");
        setTimeout(() => {
          error.classList.remove("activo");
        }, "4000");
      }else if(!celular){
        error.classList.add("activo");
        setTimeout(() => {
          error.classList.remove("activo");
        }, "4000");
      }else if(!laboral){
        error.classList.add("activo");
        setTimeout(() => {
          error.classList.remove("activo");
        }, "4000");
      }else if(!selectedValue){
        error.classList.add("activo");
        setTimeout(() => {
          error.classList.remove("activo");
        }, "4000");
      }else{
        error.classList.remove("activo");
        if(selectedValue === "visa"){
          setTarjeta("tarjetaVisa");
        }else if(selectedValue === "master") {
          setTarjeta("tarjetaMaster");
        }
        dispatch(change_estado("activo"));
      }
    }

    const handleName = (event) => {
      setName(event.target.value);
    }
    const handleCedula = (event) => {
      setCedula(event.target.value);
    }
    const handleApellido = (event) => {
      setApellido(event.target.value);
    }
    const handleEmail = (event) => {
      setEmail(event.target.value);
    }
    const handleCelular = (event) => {
      setCelular(event.target.value);
    }
    const handleLaboral = (event) => {
      setLaboral(event.target.value);
    }

    const handleChange = (event) => {
      setSelectedValue(event.target.value);
    };

    
  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: 'cards'
  });

  return (
    <Fragment>
  <div id="container">
      <div className="content">
        <div className="titulo"><img src="img/texto-front.png" alt="titulo"></img></div>
        <div id="mano"><img src="img/mano.png" alt="mano"></img></div>
        <h1>LLENÁ EL FORMULARIO Y SABREMOS QUÉ TARJETA ES PARA VOS</h1>
          <form id="contact_form">
          <label for="nombre">NOMBRE</label><br></br>
            <input type="text" id="nombre" name="nombre" tabIndex="2" onChange={handleName} />
            <br></br><br></br>
            <label for="apellido">APELLIDO</label><br></br>
            <input type="text" id="apellido" name="apellido" tabIndex="3" onChange={handleApellido} />
            <br></br><br></br>
            <label for="email">EMAIL</label><br></br>
            <input type="email" id="email" name="email" tabIndex="4" onChange={handleEmail} />
            <br></br><br></br>
            <label for="celular">CELULAR</label><br></br>
            <input type="number" id="celular" name="celular" tabIndex="5" onChange={handleCelular}/>
            <br></br><br></br>
            <label for="cedula">CÉDULA</label><br></br>
            <div id="shield">
              <img src="img/escudo-color.png" alt="escudo"></img>
              <input type="number" id="cedula" name="cedula" tabIndex="1" onChange={handleCedula} />
            </div>
            <br></br>
            <label for="laboral">SITUACIÓN LABORAL</label><br></br>
            <select id="laboral" name="laboral" tabIndex="6" onChange={handleLaboral}>
              <option value="" selected disabled hidden>Situación laboral</option>
              <option value="No trabajo">No trabajo</option>
              <option value="Trabajo independiente">Trabajo independiente</option>
              <option value="Trabajo hace menos de 1 año">Trabajo hace menos de 1 año</option>
              <option value="Trabajo hace más de 1 año">Trabajo hace más de 1 año</option>
            </select>
            <div className="clear"></div>
            <br></br><br></br>
            <div id="ingresos">
              <label>INGRESOS</label><br></br>
              <div className="ingreso">{value}</div>
              <div className="range">
                <input type="range" min="0" max="100000" step="1000" value={value} onChange={({ target: { value: radius } }) => { onChange(radius);}} />
              </div>
            </div>
            
            <div className="clear"></div>
          </form>
          <div className="clear"></div>
          <div id="tarjetas">
              <h3>¿Qué Preferís?</h3>
                <div id="tarjeta_visa"><img src="img/logo-visa.png" alt="visa"></img>
                <Radio {...controlProps('visa')} color="default" />
                </div>
                <div id="tarjeta_master"><img src="img/logo-master.png" alt="master"></img>
                <Radio {...controlProps('master')} color="default" />
                </div>
                <div className="clear"></div>
              <div className="clear"></div>
          </div>
          <div id="continuar" onClick={continuar}>CONTINUAR</div>
          <div className="clear"></div>
          <div className="error">Complete todos los campos.</div>
      </div>
      <div id="logo"><img src="img/logo-scotia.jpg" alt="logo"></img></div>      
  </div>

  { !tarjeta ? 
   null
    :
    <Tarjetas card={tarjeta} estado={tarjetaestado} ingresos={value} />
  }
    </Fragment>
  );
}

export default App;
